import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ConcretePumpingPage = lazy(() => import('../pages/services/concrete-pumping/page'));
const StoneServicesPage = lazy(() => import('../pages/services/stone-services/page'));
const BlockFillingPage = lazy(() => import('../pages/services/block-filling/page'));
const CustomMasonryPage = lazy(() => import('../pages/services/custom-masonry/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const SchedulePage = lazy(() => import('../pages/schedule/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/services/concrete-pumping', element: <ConcretePumpingPage /> },
  { path: '/services/stone-services', element: <StoneServicesPage /> },
  { path: '/services/block-filling', element: <BlockFillingPage /> },
  { path: '/services/custom-masonry', element: <CustomMasonryPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/schedule', element: <SchedulePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;